document.addEventListener("DOMContentLoaded", function () {
  function setEqualHeight() {
    const cards = document.querySelectorAll('.product-card-info');
    if (!cards.length) return;

    // Reset height first
    cards.forEach(card => card.style.height = "auto");

    // Find max height
    let maxHeight = 0;
    cards.forEach(card => {
      if (card.offsetHeight > maxHeight) {
        maxHeight = card.offsetHeight;
      }
    });

    // Apply max height to all
    cards.forEach(card => {
      card.style.height = maxHeight + "px";
    });
  }

  setEqualHeight();
  window.addEventListener("resize", setEqualHeight);
});






// (function(){
//   const targetWord = "Chan8e";
//   const classWord = "highlight-word";
//   const classEight = "highlight-8";

//   function wrapText(node){
//     let text = node.nodeValue;
//     let index = text.indexOf(targetWord);
//     if (index === -1) return;

//     const frag = document.createDocumentFragment();

//     while (index > -1) {
//       if (index > 0) {
//         frag.appendChild(document.createTextNode(text.slice(0, index)));
//       }

//       // Wrap the full word
//       const w = document.createElement("span");
//       w.className = classWord;

//       // Build Chan + <span class="highlight-8">8</span> + e
//       w.appendChild(document.createTextNode("Chan"));

//       const eight = document.createElement("span");
//       eight.className = classEight;
//       eight.textContent = "8";
//       w.appendChild(eight);

//       w.appendChild(document.createTextNode("e"));

//       frag.appendChild(w);

//       text = text.slice(index + targetWord.length);
//       index = text.indexOf(targetWord);
//     }

//     if (text.length) {
//       frag.appendChild(document.createTextNode(text));
//     }

//     node.parentNode.replaceChild(frag, node);
//   }

//   function processBody(){
//     const walker = document.createTreeWalker(
//       document.body,
//       NodeFilter.SHOW_TEXT,
//       {
//         acceptNode(node){
//           if (!node.nodeValue.includes(targetWord)) return NodeFilter.FILTER_REJECT;
//           const p = node.parentNode.tagName;
//           if (p === "SCRIPT" || p === "STYLE" || p === "NOSCRIPT") return NodeFilter.FILTER_REJECT;
//           return NodeFilter.FILTER_ACCEPT;
//         }
//       }
//     );

//     const nodes = [];
//     let n;
//     while (n = walker.nextNode()) nodes.push(n);

//     nodes.forEach(node => wrapText(node));
//   }

//   document.addEventListener("DOMContentLoaded", processBody);
// })();


(function () {
  const targetWord = "chan8e"; // lowercase target for comparison
  const classWord = "highlight-word";
  const classEight = "highlight-8";

  function wrapText(node) {
    let text = node.nodeValue;
    let lowerText = text.toLowerCase();
    let index = lowerText.indexOf(targetWord);

    if (index === -1) return;

    const frag = document.createDocumentFragment();

    while (index > -1) {
      if (index > 0) {
        frag.appendChild(document.createTextNode(text.slice(0, index)));
      }

      const original = text.substr(index, targetWord.length); // keep original case

      // Break original case word into parts: first 4 letters + 8 + last letter
      const before = original.slice(0, 4);
      const eightChar = original.charAt(4); // should be '8'
      const after = original.slice(5);

      const spanWord = document.createElement("span");
      spanWord.className = classWord;

      spanWord.appendChild(document.createTextNode(before));

      const span8 = document.createElement("span");
      span8.className = classEight;
      span8.textContent = eightChar;
      spanWord.appendChild(span8);

      spanWord.appendChild(document.createTextNode(after));

      frag.appendChild(spanWord);

      text = text.slice(index + targetWord.length);
      lowerText = text.toLowerCase();
      index = lowerText.indexOf(targetWord);
    }

    if (text.length) frag.appendChild(document.createTextNode(text));

    node.parentNode.replaceChild(frag, node);
  }

  function processBody() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue.toLowerCase().includes(targetWord)) {
            return NodeFilter.FILTER_REJECT;
          }
          const p = node.parentNode.tagName;
          if (["SCRIPT", "STYLE", "NOSCRIPT"].includes(p)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);

    nodes.forEach((node) => wrapText(node));
  }

  document.addEventListener("DOMContentLoaded", processBody);
})();

document.addEventListener("DOMContentLoaded", function () {
  const buy_now_custom = document.getElementById('buy-now-custom');
  if(buy_now_custom)
  {
    buy_now_custom.addEventListener('click', function () {
      buy_now_custom.disabled = true;
      buy_now_custom.innerText = 'Processing...';
      const form = document.querySelector('form[action="/cart/add"]');

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(response => response.json())
      .then(data => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  }
});






